import { Dispatch, SetStateAction, useState } from "react";
import { SettlementNoticeEmail } from "../../../features/api-interfaces";
import { IErrMsg } from "../constants";
import { SettlementNoticeReference } from "./SettlementNoticeReference";
import { SettlementNoticeUpdate } from "./SettlementNoticeUpdate";

interface ISettlementNotice {
  emailList: SettlementNoticeEmail[];
  setEmailList?: Dispatch<SetStateAction<SettlementNoticeEmail[]>>;
  isUpdate?: boolean;
  errMsg?: IErrMsg;
  setErrMsg?: Dispatch<SetStateAction<IErrMsg>>;
}

/**
 * 入金口座情報照会・更新 精算額通知
 */
export const SettlementNotice = (props: ISettlementNotice) => {
  const {
    emailList,
    setEmailList,
    isUpdate = false,
    errMsg,
    setErrMsg,
  } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      {isUpdate ? (
        <SettlementNoticeUpdate
          emailList={emailList}
          setEmailList={setEmailList}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      ) : (
        <SettlementNoticeReference
          emailList={emailList}
          isExpanded={isExpanded}
          setIsExpanded={setIsExpanded}
        />
      )}
    </>
  );
};
